import React from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import Button from '../buttons/Button';

const Modal = ({ body, actionButton, title, onClose, loading = false }) => (
  <ModalContainer>
    <ModalHeader title={title} onCancel={onClose} loading={loading} />
    <hr />
    <div className="bg-white text-sm md:text-base">{body}</div>
    <hr />
    <ModalFooter loading={loading} onCancel={onClose} actionButton={actionButton} />
  </ModalContainer>
);

const ModalContainer = ({ children }) => (
  <div className="absolute z-40">
    <div className="background-locked" />
    <div className="fixed h-full inset-0 z-40 w-full overflow-y-auto">
      <div className="flex p-2 lg:h-auto lg:pt-6 justify-center items-center">
        <div className="w-full max-w-3xl bg-white mx-auto p-4 md:p-8 grid gap-4 md:gap-6">{children}</div>
      </div>
    </div>
  </div>
);

const ModalHeader = ({ title, onCancel, loading }) => (
  <div className="flex items-center justify-between">
    <div className="uppercase text-sm md:text-lg">{title}</div>
    <div>
      <Button variant="secondary2" onClick={onCancel} disabled={loading}>
        <IoCloseOutline size={20} />
      </Button>
    </div>
  </div>
);

const ModalFooter = ({ onCancel, actionButton, loading }) => (
  <div className="flex w-full justify-end gap-4">
    <Button disable={loading} onClick={onCancel} variant={'action'}>
      Відміна
    </Button>
    {actionButton}
  </div>
);

export default Modal;
